
import { mapState } from "vuex";
import ReportChannelComparison from "./report-channel-comparison.vue";
import ReportOrdersCount from "./report-orders-count.vue";
import ReportChannelOrderTable from "./report-channel-order-table.vue";
import ReportItemSales from "./report-item-sales.vue";
import ReportBusinessOverall from "./report-business-overall.vue";
import ReportBusinessInsights from "./report-business-insights.vue";
import ReportCanellationReasons from "./report-canellation-reasons.vue";
import ReportStoreAvailability from "./report-store-availability.vue";
import ReportPeakHours from "./report-peak-hours.vue";
import ReportDeliveredLocation from "./report-delivered-location.vue";
import ReportOrderAcknowledgementStagesDurationTabs from "./report-order-acknowledgement-stages-duration-tabs.vue";
import AdvancePayment from "../advance-payment/advance-payment.vue";
export default {
  components: {
    ReportChannelOrderTable,
    ReportItemSales,
    ReportChannelComparison,
    ReportOrdersCount,
    ReportBusinessOverall,
    ReportBusinessInsights,
    ReportCanellationReasons,
    ReportStoreAvailability,
    ReportPeakHours,
    ReportDeliveredLocation,
    ReportOrderAcknowledgementStagesDurationTabs,
    AdvancePayment
  },
  computed: {
    ...mapState("report", ["summary", "reportLoading"])
  }
};
